import { Component, inject, Input } from '@angular/core';
import { URLUtils } from '../urlUtils';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../https.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AddNotesModalComponent } from '../modal/add-notes-modal/add-notes-modal.component';
import { LeadsService } from '../service/lead.service';

@Component({
    selector: 'app-timeline-notes',
    templateUrl: './timeline-notes.component.html',
    styleUrls: ['./timeline-notes.component.css'],
    standalone: false
})
export class TimelineNotesComponent {
  @Input() leadId: string = '';
  
  timelineNotes: any[] = [];
  colors = ['blue', 'orange', 'green', 'purple', 'yellow', 'teal', 'pink', 'red', 'cyan'];
  
  constructor(
    private leadService: LeadsService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }
  
  ngOnInit(): void {
    this.loadTimelineNotes();
  }
  
  loadTimelineNotes() {
    // this.leadService.getTimelineNotes(this.leadId).subscribe({
    //   next: (notes) => {
    //     // Assign random colors to each note for the visual indicators
    //     this.timelineNotes = notes.map((note, index) => ({
    //       ...note,
    //       color: this.colors[index % this.colors.length]
    //     }));
    //   },
    //   error: (error) => {
    //     console.error('Error loading timeline notes:', error);
    //     this.toastr.error('Failed to load timeline notes');
    //   }
    // });
  }
  
  openAddNoteModal() {
    const modalRef = this.modalService.open(AddNotesModalComponent, {
      centered: true,
      size: 'lg'
    });
    
    modalRef.componentInstance.leadId = this.leadId;
    
    modalRef.result.then(
      (result) => {
        if (result) {
          this.toastr.success('Note added successfully');
          this.loadTimelineNotes(); // Reload notes after adding
        }
      },
      () => {} // Dismissed
    );
  }
}
